const Profile = ()=>{
    return(
        <div>
            <h1>Hi I am Shlok</h1>
        </div>

    )
}

export default Profile;